import React from "react";
import {useIntl} from "react-intl";
import {Badge, capitalizeFirstLetter, DescriptionListItem, TextSkeleton} from "peggirkit";
import useAuth from "@/context/authentication/use-auth";
import DescriptionListCard from "../../../descriptionList/DescriptionListCard";
import {UserRole} from "@/data/entities/user";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";

const GeneralSettingsTab = () => {
    const intl = useIntl();
    const {user} = useAuth();
    const {dashboardLocation} = useRestaurant();

    return (
        <DescriptionListCard
            title={intl.formatMessage({id: "general"})}
            description={intl.formatMessage({id: "generalAccountDetails"})}
        >
            <DescriptionListItem
                title={intl.formatMessage({id: "emailAddress"})}
                content={user === null
                    ? <TextSkeleton className={"max-w-[200px]"}/>
                    : capitalizeFirstLetter(user?.username)
                }
            />

            <DescriptionListItem
                title={intl.formatMessage({id: "preferredLocation"})}
                tooltip={intl.formatMessage({id: "preferredLocation.tip"})}
                content={dashboardLocation.name}
            />

            <DescriptionListItem
                title={intl.formatMessage({id: "rights"})}
                content={user === null
                    ? <TextSkeleton className={"max-w-[200px]"}/>
                    : (
                        <div className={"flex flex-row flex-wrap gap-3"}>
                            {user.roles.map((role: UserRole, ix: number) => (
                                <Badge key={ix} color={"secondary"}>{role.name}</Badge>
                            ))}
                        </div>
                    )
                }
            />
        </DescriptionListCard>
    );
};

export default GeneralSettingsTab;